/**
 * Canonical forward-facing product mark for AmeriCon™.
 * Use Unicode U+2122 so nav, dashboards, emails, Stripe line items, and JSX text stay consistent.
 */
export const AMERICON_MARK = 'AmeriCon™';

/** Product name without trademark symbol — for composition where TM is added separately. */
export const AMERICON_NAME = 'AmeriCon';
